import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import flatMap from 'lodash/flatMap';
var DEFAULT_GROUP = 'default';
export default function getButtonsFromPlugins(editor, key) {
  var groups = flatMap(editor.controller.middleware[key], function (plugin) {
    return plugin instanceof Function ? plugin() : plugin;
  }).reduce(function (buttonsByGroup, button) {
    if (!button) return buttonsByGroup;
    var groupKey = button.buttonGroup || DEFAULT_GROUP;
    var list = buttonsByGroup[groupKey] || [];
    return _objectSpread({}, buttonsByGroup, _defineProperty({}, groupKey, [].concat(_toConsumableArray(list), [button])));
  }, {
    "default": []
  }); // Groups is of the form:
  // { [groupName] : [{id, ...options}, ...]}
  // Here we take each group and sort its items according to the options.index

  return Object.entries(groups).reduce(function (result, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        entries = _ref2[1];

    return _objectSpread({}, result, _defineProperty({}, key, entries.sort(function (pluginA, pluginB) {
      if (pluginA.index && pluginB.index) {
        return pluginA.index < pluginB.index ? -1 : 1;
      } else if (pluginA.index) {
        return -1;
      } else if (pluginB.index) {
        return 1;
      }

      return 0;
    })));
  }, {});
} // [{category: 'plop', items : [{}]}]